import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
//Models
import { Infrastructure, InfrastructureTypeEnum } from '@mocca-technologies/model';
//Utils
import * as icons from 'src/assets/icons';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-color-legend',
  templateUrl: './color-legend.component.html',
  styleUrls: ['./color-legend.component.scss'],
})
export class ColorLegendComponent implements OnInit, OnChanges {

  icons = icons;

  /**
   * Inputs and Variables
   */
  @Input() infraList: Infrastructure[] = [];
  @Input() bottomPosition: boolean = false;
  types: Set<string> = new Set();
  typesArray: [InfrastructureTypeEnum, boolean][] = [];

  showLegend: boolean = true;

  constructor(
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
  ) {}

  //#region --> LifeCycle

  ngOnInit() {
    if (this.infraList?.length > 0) {
      this.getTypes();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['infraList'] && this.infraList?.length > 0) {
      this.getTypes();
    }
  }

  //#endregion

  //#region --> Methods

  /**
   * Given an infrastructure list, gets a set of types and manual coordinations or not
   * then updates the typesArray
   */
  getTypes() {
    this.types = new Set();
    this.infraList.forEach(infra => {
      // Handle both 'type' and 'infraType' property names for compatibility
      const infraType = (infra as any)?.type || (infra as any)?.infraType;
      const manualCoord = (infra as any)?.manualCoordination ?? false;
      this.types.add(JSON.stringify([infraType, manualCoord]));
    });
    this.updateTypesArray();
  }

  /**
   * Updates the typesArray to store the list of types and manual coordinations
   * and sort them alphabetically first, then by manual coordination (true first)
   */
  updateTypesArray() {
    this.typesArray = Array.from(this.types)
      .map(item => JSON.parse(item) as [InfrastructureTypeEnum, boolean])
      .sort((a, b) => {
        // If the infrastructure types are the same, sort by the boolean value
        if (a[0] === b[0]) {
          // Put true values before false values
          return a[1] === b[1] ? 0 : a[1] ? -1 : 1;
        }
        // Otherwise, sort alphabetically by the infrastructure type
        return a[0].localeCompare(b[0]);
      });
    this.cdr.detectChanges();
  }

  /**
   * Get the display text for an infrastructure type
   * Uses TranslateService or falls back to the type string
   */
  getInfrastructureTypeText(type: InfrastructureTypeEnum): string {
    const translationKey = `INFRASTRUCTURES.TYPE.${type}`;
    return this.translateService.instant(translationKey) || type;
  }

  //#endregion

  //#region --> Manage Visualization

  /**
   * Toggles the visibility of the legend
   */
  toggleLegend() {
    if (!this.showLegend) {
      this.getTypes();
    }
    this.showLegend = !this.showLegend;
  }

  //#endregion

}
